import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import { DEPENDENT_FORM_STEPS } from '../../../redux/dependentForm/progress.actions';
import Button from '../../Button';
import { usePersonalInfoForm } from '../utils/usePersonalInfoFormState';
import deepTrim from '../../../utils/converters/deepTrim';
import { PersonalInfoForm } from './PersonalInfoForm';
import { IDS } from '../../../constants/ids';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

const DependentPersonalInfo = ({
  dataValidationErrors: errors,
  clearPersonalReq,
  titleWithRole,
  formatMessage,
  genderList,
  nameSuffixList,
  goNext,
  pending,
}) => {
  const {
    handleFormChange,
    validateErrors,
    clearErrors,
    formState,
    isValid,
  } = usePersonalInfoForm(errors);
  usePageView('Add Dependent | Personal Info');

  useEffect(() => clearPersonalReq, []);

  const handleSubmit = e => {
    e.preventDefault();
    clearErrors();
    goNext({
      step: DEPENDENT_FORM_STEPS.PERSONAL,
      data: deepTrim(formState),
    });
  };

  return (
    <div styleName="section">
      <MetaHelmet title="pages.title.dependentPersonal" />
      {titleWithRole}

      <div styleName={cn('content', { disabled: pending })}>
        <form onSubmit={handleSubmit}>
          <label styleName="form--label">
            {formatMessage({ id: 'profile.section.personal' })}
          </label>

          <PersonalInfoForm
            {...formState}
            nameSuffixList={nameSuffixList}
            genderList={genderList}
            formatMessage={formatMessage}
            validateErrors={validateErrors}
            onChange={handleFormChange}
          />

          <div styleName="btn-block">
            <Button
              className="mr3"
              id={IDS.ADD_DEPENDENT.NEXT}
              type="submit"
              raised
              color="primary"
              disabled={!isValid || pending}
            >
              {formatMessage({ id: 'common.next' })}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

DependentPersonalInfo.propTypes = {
  goNext: PropTypes.func,
  clearPersonalReq: PropTypes.func,
  titleWithRole: PropTypes.node,
  formatMessage: PropTypes.func,
  genderList: PropTypes.array,
  nameSuffixList: PropTypes.array,
  pending: PropTypes.bool,
  dataValidationErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default enhance(DependentPersonalInfo);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentPersonalInfo/index.jsx